// import * as actions from '../redux/actions';
// import * as commonActions from '../common/redux/actions';

import * as homeActions from '../home/redux/apiCall';

import { KuposButton, KuposInput } from '../common';
import React, { Component, useEffect, useState } from 'react';

import { AppData } from '../../services';
import KuposErrorSuccessModal from './KuposErrorSuccessModal';
import KuposModal from './KuposModal';
import KuposSuccessFailure from './KuposSuccessFailure';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const validateEmail = email => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};
const ContactForm = ({ icon, label, actions, t }) => {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [comment, setComment] = useState('');
  const [commentError, setCommentError] = useState('');

  const [response, setResponse] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [modalBodyText, setModalBodyText] = useState(null);
  const [modalButton1, setModalButton1] = useState(null);

  const handleSubmit = () => {
    if (!name || !phone || !validateEmail(email) || !comment) {
      if (!name) setNameError('VALIDATIONS.VALID_NAME');
      if (!phone) setPhoneError('VALIDATIONS.VALID_MOBILE');
      if (phone > 9 && phone < 9) setPhoneError('VALIDATIONS.VALID_MOBILE_LENGTH_9');
      if (!email) setEmailError('VALIDATIONS.VALID_EMAIL');
      if (!validateEmail(email)) setEmailError('VALIDATIONS.VALID_EMAIL_VALIDATION');
      if (!comment) setCommentError('VALIDATIONS.VALID_COMMENT');
      return;
    }

    setLoading(true);
    const data = {
      name: name,
      email: email,
      telephone: phone,
      comments: comment,
    };
    actions
      .apiCall({
        url: AppData.BASE_URL + 'api/pullman/base/contact_info',
        method: 'POST',
        data: data,
      })
      .then(res => {
        console.log('res', res);
        setResponse(res);
        setLoading(false);
        setShowModal(true);
        setModalText('CONTACT_FORM.MODAL_TITLE');
        setModalBodyText('CONTACT_FORM.MODAL_BODY');
        setModalButton1(t('CONTACT_FORM.MODAL_BUTTON'));
      });
  };

  const onBlurChange = (val, type) => {
    if (type === 'phone-no') {
      if (!val) {
        setPhoneError('VALIDATIONS.VALID_MOBILE');
      } else if (val.length > 9 || val.length < 9) {
        setPhoneError('VALIDATIONS.VALID_MOBILE_LENGTH_9');
      }
    } else if (type === 'email') {
      if (!val) {
        setEmailError('VALIDATIONS.VALID_EMAIL');
      }
      if (!validateEmail(val)) {
        setEmailError('VALIDATIONS.VALID_EMAIL');
      }
    } else if (!val) {
      if (type === 'name') {
        setNameError('VALIDATIONS.VALID_NAME');
      } else if (type === 'comment') {
        setCommentError('VALIDATIONS.VALID_COMMENT');
      }
    }
  };

  const reset = () => {
    setName('');
    setPhone('');
    setEmail('');
    setComment('');
  };

  return (
    <React.Fragment>
      <KuposErrorSuccessModal
        showModal={showModal}
        success={modalText}
        onButtonClick={() => {
          setShowModal(false);
          setModalText('');
          // console.log('button');
          reset();
        }}
        bodyText={modalBodyText}
        showButton1={true}
        buttonText1={modalButton1}
        onButtonClick1={() => {
          setShowModal(false);
          console.log('button123');

          reset();
        }}
        t={t}
      />

      <div className="contact-form kupos-card">
        <div className="font13 bold-text">{t('CONTACT_FORM.NEED_SUPPORT')}</div>
        <div className="yellow-line" />
        <div className="font10">{t('CONTACT_FORM.SUB_HEADER_TITLE')}</div>
        <div className="inputs">
          <div className="contact-inp">
            <KuposInput
              className="kupos-border"
              type="text"
              label={t('CONTACT_FORM.NAME')}
              placeholder={'María Teresa'}
              value={name}
              onChange={text => {
                setName(text);
                setNameError('');
              }}
              onBlur={text => onBlurChange(text, 'name')}
              error={nameError ? true : false}
              errorMessage={t(nameError)}
            />
          </div>
          <div className="two-inputs">
            <div className="contact-inp">
              <KuposInput
                className="kupos-border"
                type="tel"
                label={t('CONTACT_FORM.PHONE_NUMBER')}
                placeholder={'9XXXXXXXX'}
                value={phone}
                onChange={text => {
                  setPhone(text);
                  setPhoneError('');
                }}
                onBlur={text => onBlurChange(text, 'phone-no')}
                error={phoneError ? true : false}
                errorMessage={t(phoneError)}
              />
            </div>

            <div className="contact-inp">
              <KuposInput
                className="kupos-border"
                type="email"
                label={t('CONTACT_FORM.EMAIL')}
                placeholder={'ejemplo@gmail.com'}
                value={email}
                onChange={text => {
                  setEmail(text);
                  setEmailError('');
                }}
                onBlur={text => onBlurChange(text, 'email')}
                error={emailError ? true : false}
                errorMessage={t(emailError)}
              />
            </div>
          </div>
          <div className="contact-inp">
            <KuposInput
              className="kupos-border"
              type="text"
              label={t('CONTACT_FORM.COMMENT')}
              placeholder={'Opcional'}
              value={comment}
              onChange={text => {
                setComment(text);
                setCommentError('');
              }}
              onBlur={text => onBlurChange(text, 'comment')}
              error={commentError ? true : false}
              errorMessage={t(commentError)}
            />
          </div>
          <div className="contact-submit">
            <KuposButton disabled={loading} onClick={handleSubmit}>
              {loading ? 'Loading...' : t('CONTACT_FORM.SEND')}
            </KuposButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

/* istanbul ignore next */
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(ContactForm));



// WEBPACK FOOTER //
// ./src/features/common/ContactForm.js